/**
 * SurfaceChatPanel — the column's occupant while the stage is EXPANDED.
 *
 * Mounts the platform's own chat (Twitch/Kick embed) inside the anchor's
 * `.sh-pn` panel shell. The stage keeps the viewer here only if the room to
 * talk is here too — see the EXPANDED comment in `HubSpine.scss`.
 */

import React from "react";

export interface SurfaceChatSource {
    /** "TWITCH" | "KICK" — anything else renders nothing. */
    platform: string;
    /** Channel login/slug as the platform's embed expects it. */
    channel: string;
}

function chatEmbedUrl(chat: SurfaceChatSource): string | undefined {
    const channel = encodeURIComponent(chat.channel);
    switch (chat.platform.toUpperCase()) {
        case "TWITCH":
            return `https://www.twitch.tv/embed/${channel}/chat?parent=${window.location.hostname}&darkpopout`;
        case "KICK":
            return `https://kick.com/popout/${channel}/chat`;
        default:
            return undefined;
    }
}

export const SurfaceChatPanel: React.FC<{ chat: SurfaceChatSource }> = ({chat}) => {
    const src = chatEmbedUrl(chat);
    if (!src) return null;
    return (
        <div className="sh-pn">
            <div className="sh-pn__h">
                <span className="sh-pn__k">Chat</span>
                <span className="sh-pn__x">{chat.channel}</span>
            </div>
            {/* Scale wrapper — the only compactness lever over a cross-origin embed. */}
            <div className="sh-ch__scale">
                <iframe
                    className="sh-ch__if"
                    title={`${chat.channel} chat`}
                    src={src}
                    frameBorder="0"
                />
            </div>
        </div>
    );
};
